(function () {
  'use strict';

  var attempts = 0;

  function rootNode() {
    return document.querySelector('[data-regenere-offer-test], [data-eclo-supp-offer-v15]');
  }

  function normalizeMode(value) {
    var mode = String(value || '').toLowerCase();
    return mode === 'subscription' || mode === 'sub' ? 'subscription' : 'onetime';
  }

  function requestedMode(root) {
    var params = new URLSearchParams(window.location.search);
    var explicit = String(params.get('mode') || '').toLowerCase();
    if (explicit) return normalizeMode(explicit);

    /* Theme Editor / V6 controller is authoritative over the legacy block default. */
    var configured = (window.ECLOOfferTheme && window.ECLOOfferTheme.defaultMode) ||
      (window.ECLOOfferV6 && window.ECLOOfferV6.defaultMode);
    if (configured) return normalizeMode(configured);

    var rootDefault = root && root.getAttribute('data-default-mode');
    if (rootDefault) return normalizeMode(rootDefault);

    return selectedMode(root);
  }

  function requestedMonths(root) {
    var params = new URLSearchParams(window.location.search);
    var explicit = parseInt(params.get('cure') || '', 10);
    if ([1, 2, 3].indexOf(explicit) >= 0) return explicit;

    var configured = parseInt(
      (window.ECLOOfferTheme && window.ECLOOfferTheme.defaultMonths) ||
      (window.ECLOOfferV6 && window.ECLOOfferV6.defaultMonths) || '',
      10
    );
    if ([1, 2, 3].indexOf(configured) >= 0) return configured;

    var rootDefault = root && parseInt(root.getAttribute('data-default-months') || root.getAttribute('data-default-duration') || '', 10);
    if ([1, 2, 3].indexOf(rootDefault) >= 0) return rootDefault;

    return selectedMonths(root);
  }

  function selectedMode(root) {
    var selected = root && root.querySelector('[data-regenere-modes] [data-mode].is-selected, [data-eclo-supp-modes-v15] [data-mode].is-selected');
    return selected && selected.getAttribute('data-mode') === 'subscription' ? 'subscription' : 'onetime';
  }

  function selectedMonths(root) {
    var selected = root && root.querySelector('[data-regenere-tiers] [data-months].is-selected, [data-eclo-supp-tiers-v15] [data-months].is-selected');
    var months = selected ? parseInt(selected.getAttribute('data-months') || '1', 10) : 1;
    return [1, 2, 3].indexOf(months) >= 0 ? months : 1;
  }

  function applyV6(root, mode) {
    if (!window.ECLOOfferV6 || !window.ECLOOfferV6.enabled) return false;
    if (window.ECLOOfferV6.defaultMode !== mode) {
      window.ECLOOfferV6.defaultMode = mode;
      if (window.ECLOOfferTheme) window.ECLOOfferTheme.defaultMode = mode;
      document.dispatchEvent(new CustomEvent('eclo:offer-v6-refresh'));
    }
    return !!root.querySelector('[data-eclo-offer-v6]');
  }

  function applyA(root, mode) {
    var button = root.querySelector('[data-proto-mode-head="' + mode + '"]');
    if (!button) return false;
    if (selectedMode(root) !== mode) button.click();
    var months = requestedMonths(root);
    if (selectedMonths(root) !== months) {
      var monthButton = root.querySelector('[data-proto-months="' + months + '"]');
      if (monthButton) monthButton.click();
    }
    return true;
  }

  function applyD(root, mode) {
    var switchButton = root.querySelector('[data-structured-subscription]');
    if (!switchButton) return false;
    if (selectedMode(root) !== mode) switchButton.click();
    return true;
  }

  function applyF(root, mode) {
    var switchButton = root.querySelector('[data-f-switch]');
    if (!switchButton) return false;
    if (selectedMode(root) !== mode) switchButton.click();
    return true;
  }

  function applyFc(root, mode) {
    var switchButton = root.querySelector('[data-fc-switch]');
    if (!switchButton) return false;
    if (selectedMode(root) !== mode) switchButton.click();
    return true;
  }

  function apply() {
    var root = rootNode();
    if (!root) {
      if (attempts++ < 80) window.setTimeout(apply, 75);
      return;
    }

    var layout = String((window.ECLOOfferV6 && window.ECLOOfferV6.layout) || (window.ECLOOfferTheme && window.ECLOOfferTheme.layout) || 'f3').toLowerCase();
    var mode = requestedMode(root);
    var done = false;

    /* Shared V6 wins whenever enabled, including Régénère A. */
    if (window.ECLOOfferV6 && window.ECLOOfferV6.enabled) {
      done = applyV6(root, mode);
      if (done && window.ECLOOfferV6SuppParity && window.ECLOOfferV6SuppParity.refresh) {
        window.ECLOOfferV6SuppParity.refresh();
      }
    } else if (layout === 'a') done = applyA(root, mode);
    else if (layout === 'd') done = applyD(root, mode);
    else if (layout === 'f') done = applyF(root, mode);
    else if (layout === 'f3' || layout === 'f4') done = applyFc(root, mode);
    else done = applyV6(root, mode);

    if (!done && attempts++ < 80) window.setTimeout(apply, 75);
  }

  window.ECLOOfferV6Bridge = { apply: apply };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();

  document.addEventListener('shopify:section:load', function () {
    attempts = 0;
    window.setTimeout(apply, 0);
  });
  document.addEventListener('eclo:offer-v6-config', function () {
    attempts = 0;
    window.setTimeout(apply, 0);
  });
})();
